// Ouverture du menu mobile

const valueResponsiveMenu = 1120;

$(function () {
    let $witdhWindow = $(window).width();
    if ($witdhWindow <= valueResponsiveMenu) {
        //
    } else {
        showEventInProgressBox();
    }
});


// Affichage VENTES A VENIR
function showEventInProgressBox() {

    $(document).on('mouseenter mouseleave', ".show-vente, #vente-in-progress", function () {
        $('#vente-in-progress').toggleClass('active');
    });
}

// Fermeture CALENDRIER DES VENTES
$(document).on("click", "#close-calendar-vente", function () {
    $("#calendar-vente").removeClass("active");
});

// Fermeture VENTES A VENIR
$(document).on("click", "#close-vente-in-progress", function () {
    $('#vente-in-progress').removeClass("active");
});

// Affichage CALENDRIER DES VENTES
$(document).on("click", "#show-calendar", function () {
    if ($("#calendar-vente").hasClass('active')) {
        $("#calendar-vente").removeClass("active");
    } else {
        $("#calendar-vente").addClass("active");
    }
});

// Fermeture du MENU ESTIMATION
$(document).on("click", ".close-expertise", function () {
    $("#menu-estimation").removeClass("active");
})

$(document).on("click", "#display-estimation", function () {
    if ($("#menu-estimation").hasClass('active')) {
        $("#menu-estimation").removeClass("active");
    } else {
        $('#calendar-vente').removeClass("active");
        $("#menu-estimation").addClass("active");
    }
});